import React, { useCallback, useEffect, useState } from "react";
import {
  Button,
  Row,
  Col,
  Card,
  Nav,
  Tab,
  Dropdown,
  Table,
  Badge,
  Accordion,
  useAccordionButton,
} from "react-bootstrap";
import classNames from "classnames";
import { NavLink } from "react-router-dom";
import { LAYOUT } from "constants.js";
import CsLineIcons from "cs-line-icons/CsLineIcons";

import { useWindowSize } from "hooks/useWindowSize";
import Clamp from "components/clamp";
import PropTypes from "prop-types";

import Bio from "./bio";
import Academics from "./academics";
import Workex from "./workex";
import Projects from "./projects";
import Consulting from "./consulting";
import TrainingCertifications from "./training-certifications";
import Connections from "./connections";
import Overview from "./overview";

const MoreItemToggle = React.forwardRef(({ onClick, parentClassname }, ref) => (
  <a
    ref={ref}
    className={classNames("btn btn-icon btn-icon-only", {
      "btn-foreground mt-2": parentClassname.indexOf("nav-tabs-title") === -1,
      "btn-background pt-0 bg-transparent pe-0":
        parentClassname.indexOf("nav-tabs-title") > -1,
    })}
    href="#/"
    onClick={(e) => {
      e.preventDefault();
      onClick(e);
    }}
  >
    <CsLineIcons icon="more-horizontal" size="20" />
  </a>
));

MoreItemToggle.displayName = "MoreItemToggle";
// eslint-disable-next-line no-unused-vars
const ResponsiveNav = React.forwardRef(({ className, children }, ref) => {
  const innerRef = React.createRef();
  const [collapseIndex, setCollapseIndex] = useState(children.length);
  const [childSteps, setChildSteps] = useState([]);
  const { width } = useWindowSize();

  const setSteps = () => {
    const steps = [];
    const currentChildren = innerRef.current.children;
    let totalWidth = 0;
    for (let i = 0; i < currentChildren.length; i += 1) {
      totalWidth += currentChildren[i].clientWidth;
      steps.push(totalWidth);
    }
    setChildSteps(steps);
  };
  const checkCollapseIndex = () => {
    const navWidth = innerRef.current.clientWidth;
    let checkedCollapseIndex = childSteps.filter((x) => x < navWidth).length;
    if (checkedCollapseIndex < children.length) {
      checkedCollapseIndex = childSteps.filter((x) => x < navWidth - 50).length;
    }
    if (checkedCollapseIndex !== collapseIndex) {
      setCollapseIndex(checkedCollapseIndex);
    }
  };
  useEffect(() => {
    setSteps();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (width && childSteps.length > 0) {
      checkCollapseIndex();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [width]);

  return (
    <div ref={innerRef} className={className}>
      {children.slice(0, collapseIndex)}
      {collapseIndex !== children.length && (
        <Dropdown className={classNames("nav-item ms-auto pe-0")} alignRight>
          <Dropdown.Toggle as={MoreItemToggle} parentClassname={className} />
          <Dropdown.Menu>
            {children.slice(collapseIndex, children.length)}
          </Dropdown.Menu>
        </Dropdown>
      )}
    </div>
  );
});

const Portfolio = ({ user, ...props }) => {
  const [activeTab, setactiveTab] = useState("Overview");
  const tabHandler = useCallback((key) => {
    setactiveTab(key);
  }, []);

  return (
    <>
      <Row className="g-2">
        {/* Sidebar Start */}
        <Col xl="4" xxl="3" className="d-none d-xxl-block">
          <h2 className="small-title">Biography</h2>
          <Bio user={user} />
        </Col>
        {/* Sidebar End */}

        {/* Content Start */}
        <Col md="12" xxl="9">
          <Tab.Container
            defaultActiveKey="Overview"
            onSelect={(e) => setactiveTab(e)}
            activeKey={activeTab}
          >
            <Nav
              variant="tabs"
              className="nav-tabs-title nav-tabs-line-title"
              activeKey={activeTab}
              as={ResponsiveNav}
            >
              <Nav.Item>
                <Nav.Link eventKey="Overview">Overview</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="Academics">Academics</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="Projects">Projects</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="Trainings">
                  Training & Certifications
                  {/* incl. Project, Trainings & Certifications */}
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="Workex">Work Experience</Nav.Link>
              </Nav.Item>
              <Nav.Item className="d-xxl-none">
                <Nav.Link eventKey="Bio">About Me</Nav.Link>
              </Nav.Item>
              {/* 
              <Nav.Item><Nav.Link eventKey="Consulting">Consulting<sup className="text-primary text-small super-count-borderless">02</sup></Nav.Link></Nav.Item>              
              <Nav.Item><Nav.Link eventKey="Connections">Connections</Nav.Link></Nav.Item>
              */}
            </Nav>
            <Tab.Content>
              <Tab.Pane eventKey="Overview">
                <Overview user={user} tabHandler={tabHandler} />
              </Tab.Pane>
              <Tab.Pane eventKey="Academics">
                <Academics user={user} />
              </Tab.Pane>
              <Tab.Pane eventKey="Projects">
                <Projects user={user} />
              </Tab.Pane>
              <Tab.Pane eventKey="Trainings">
                <TrainingCertifications user={user} />
              </Tab.Pane>
              <Tab.Pane eventKey="Workex">
                <Workex user={user} />
              </Tab.Pane>
              <Tab.Pane eventKey="Bio" className="d-xxl-none">
                <Bio user={user} />
              </Tab.Pane>
              {/*
              <Tab.Pane eventKey="Consulting">
                <Consulting />
              </Tab.Pane>
              <Tab.Pane eventKey="Connections">
                <Connections />
              </Tab.Pane>
              */}
            </Tab.Content>
          </Tab.Container>
        </Col>
        {/* Content End */}
      </Row>
    </>
  );
};

export default Portfolio;
Portfolio.propTypes = {
  user: PropTypes.object.isRequired,
};
